module.exports = __webpack_public_path__ + "static/media/step-challenge-banner-desktop.d01899e9.jpg";